// Owner: editor-kit. Editor-kit commands an editor adds to its own scope (plan §4.2): ⌘S saves now
// (there is no Save button — autosave keeps everything — but the habit deserves a calm answer instead
// of the browser's "Save page as" dialog).
import { type Scope, defineCommand } from '@dataroom/interaction';
import { toast } from '@dataroom/ui';
import { t } from '../lib/i18n';

export type SaveNowContext = { saveNow: () => Promise<boolean> | boolean | void };

/** `mod+s` → `ctx.saveNow()` and a quiet "Saved" toast; works while typing. */
export function saveNowCommand<Ctx extends SaveNowContext>(scope: Scope<Ctx>, id = `${scope.id}.saveNow`) {
  return defineCommand<Ctx>({
    id,
    title: () => t('editorKit.commands.saveNow'),
    shortcut: 'mod+s',
    scope,
    textSafe: true,
    run: (ctx) => {
      void Promise.resolve(ctx.saveNow()).then((ok) =>
        toast({
          title: ok === false ? t('editorKit.commands.saveNowPending') : t('editorKit.commands.savedNow'),
          body: ok === false ? undefined : t('editorKit.commands.savedNowBody'),
          tone: ok === false ? 'warn' : 'ok',
          dedupeKey: 'editor-kit-save-now',
          durationMs: 2500,
        }),
      );
    },
  });
}
